module.exports = __webpack_public_path__ + "static/media/logo.d7e3135d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 251
// module chunks = 0